module.exports = __webpack_public_path__ + "img/conny-f-stage7-sulking.50c639bc.png";